/** Math expression condition node definition. */

import type { NodeDefinition } from '../types';
import type { FlowNode } from '../../../types/flow-types';
import { create_math_condition } from '../../../../Scenes/helpers/ui_conditions_to_scene';

export const mathConditionDefinition: NodeDefinition = {
	type: 'mathCondition',
	category: 'condition',
	sourceHandles: ['true', 'false'],

	defaultData: () => ({
		label: 'Math Expression',
		expression: '',
		params: [],
		mathScript: {},
	}),

	toSceneJson: (node: FlowNode) => {
		if (node.data.sceneData) {
			return { ...(node.data.sceneData as any), _fid: node.id };
		}

		const result = create_math_condition({
			math_script: node.data.mathScript,
			expression: node.data.expression,
			params: node.data.params,
		});
		return result ? { ...result, _fid: node.id } : null;
	},
};
